import { service } from "../utils/request.js";
let request = service;
//get
export function getAction(url,params) {
  return request({
    url: url,
    method: 'get',
    params: params,
  })
}
// post
export function postAction(url,data) {
  return request({
    url: url,
    method: 'post',
    data: data,
  })
}
// put
export function putAction(url,data) {
  return request({
    url: url,
    method: 'put',
    data: data,
  })
}
// delete
export function deleteAction(url,params) {
  return request({
    url: url,
    method: 'delete',
    params: params,
  })
}
// export
export function exportAction(url,data) {
  return request({
    url: url,
    method: 'post',
    responseType:'blob',
    data
  })
}
export function goLogin(data) {
  // ?????
  return request({
    url: "sys/login",
    method: "post",
    data,
    code: "v4",
  });
}
export function goLogins(data) {
  // ?????
  return request({
    // url: "/sys/plogin",
    url: "/sys/phoneLogin",
    method: "post",
    data,
    code: "v4",
  });
}
export function LogOut() {
  // ???????????
  return request({
    url: "/sys/logout",
    method: "get",
    code: "v4",
  });
}

export function getCaptcha(currdatetime) {
  //?????????
  return request({
    url: `sys/randomImage/${currdatetime}`,
    method: "get",
    code: "_t=",
  });
}

export function fileUpdate(data) {
  // ???????
  return request({
    url: "/sys/common/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    code: "",
  });
}
export function fileUp(data) {
  // ???????
  return request({
    url: "/sys/common/local/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    code: "",
  });
}
export function fileUps(data,onProgress) {
  // ???????
  return request({
    url: "/sys/common/local/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      if (typeof onProgress === 'function' && progressEvent.lengthComputable) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percent);
      }
    },
    code: "",
  });
}
// ??????????????????
export function chunkUpload(data, onProgress) {
  return request({
    url: "/sys/common/chunk/upload",
    method: "post",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      if (typeof onProgress === 'function' && progressEvent.lengthComputable) {
        onProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  });
}
export function lxApplyFileList(data) {
  // ???????????????
  return request({
    url: "lx/lxApply/saveOrUpdate",
    method: "post",
    data,
    code: "",
  });
}

export function lxAddUser(data) {
  //?????????
  return request({
    url: "/sys/user/lxadd",
    method: "post",
    data,
    code: "",
  });
}

export function lxEditUser(data) {
  //?????????
  return request({
    url: "/sys/user/lxedit",
    method: "post",
    data,
    code: "",
  });
}

export function lxDeleteUser(data) {
  //???????????
  return request({
    url: "/sys/user/lxdelete",
    method: "delete",
    params: data,
    code: "",
  });
}

export function lxApplySaveOrUpdate(data) {
  //???????
  return request({
    url: "lx/lxApply/saveOrUpdate",
    method: "post",
    data,
    code: "",
  });
}

export function lxApplyApplylist(params) {
  //????????-????
  return request({
    url: `/lx/lxApply/applylist`,
    method: "get",
    params,
  });
}

export function lxApplyjApplylist(params) {
  //????????????????-????
  return request({
    url: `/lx/lxApply/jyjApplylist`,
    method: "get",
    params,
  });
}
export function lxApplytApplylist(params) {
  //??????????????-????
  return request({
    url: `/lx/lxApply/zjyjApplylist`,
    method: "get",
    params,
  });
}

export function lxApplyApplyDelete(data) {
  //????????-??????
  return request({
    url: `lx/lxApply/delete?id=${data.id}`,
    method: "delete",
    data,
    code: "",
  });
}

export function userLxList(data) {
  //??????????-????
  return request({
    url: "/sys/user/lxlist",
    method: "get",
    params: data,
    // code: "",
  });
}

export function userLxApplyDateView() {
  //????????-???????????-????
  return request({
    url: "/lx/lxApply/applyDateView",
    method: "get",
    // params:data,
    // code: "",
  });
}

export function userLxApplyDateSet(data) {
  //????????-???????????-??
  return request({
    url: "/lx/lxApply/applyDateSet",
    method: "post",
    data,
    code: "",
  });
}

export function userLxExpertDateView() {
  //????????-?????????-????
  return request({
    url: "/lx/lxApply/expertDateView",
    method: "get",
    // params:data,
    // code: "",
  });
}

export function userLxExpertDateSet(data) {
  //????????-?????????-??
  return request({
    url: "/lx/lxApply/expertDateSet",
    method: "post",
    data,
    code: "",
  });
}

export function userCheck(data) {
  //?????????????
  return request({
    url: "/sys/duplicate/check",
    method: "get",
    params: data,
    // code: "",
  });
}

export function applyDateView(data) {
  //???????????????
  return request({
    url: "/lx/lxApply/applyDateView",
    method: "get",
    params: data,
    // code: "",
  });
}

export function schoolMaxNum(data) {
  //?????????????????????????????
  return request({
    url: "/lx/lxSchoolMaxNum/schoolMaxNum",
    method: "get",
    params: data,
    // code: "",
  });
}

export function expertDateView(data) {
  //?????????????
  return request({
    url: "/lx/lxApply/expertDateView",
    method: "get",
    params: data,
  });
}

export function lxApplyApplySettingData(data) {
  //????? ????????-?????-??????????????????????????
  return request({
    url: "/lx/lxApply/applySettingData",
    method: "get",
    params: data,
    // code: "",
  });
}

export function schoolNumList(data) {
  //?????????????????????
  return request({
    url: "/lx/lxSchoolMaxNum/schoolNumList",
    method: "get",
    params: data,
    // code: "",
  });
}

export function lxExpertApplyAdd(data) {
  //????????-?????-??????????????
  return request({
    url: "/lx/lxExpertApply/add",
    method: "post",
    data,
    // code: "",
  });
}

export function getLxExpertList(data) {
  //????????-?????-????????????
  return request({
    url: `/sys/user/lxAllList`,
    method: "get",
    params: data,
  });
}

export function updatePassword(data) {
  // ???????
  return request({
    url: "/sys/user/updatePassword",
    method: "put",
    data,
  });
}

export function schoolNumSet(data) {
  // ????????????????????????
  return request({
    url: "/lx/lxSchoolMaxNum/schoolNumSet",
    method: "post",
    data,
  });
}
export function lxApplyZjApplyList(params) {
  // ???????????????
  return request({
    url: `/lx/lxApply/zjApplylist`,
    method: "get",
    params,
  });
}
export function lxExpertApplyReview(data) {
  // ??????
  return request({
    url: "/lx/lxExpertApply/evaluate",
    method: "post",
    data,
  });
}
export function resetPasswords(data) {
  // ???????
  return request({
    url: "/sys/user/resetPassword",
    method: "put",
    data,
  });
}
export function userLxExport(params) {
  // ????
  return request({
    url: "/sys/user/lxExportXls",
    method: "GET",
    responseType: "blob",
    params,
  });
}
export function userLxImport(data) {
  // ????
  return request({
    url: "/sys/user/lxImportExcel",
    method: "post",
    data,
  });
}
export function deleteFile(params) {
  // ??????????
  return request({
    url: "/lx/lxApply/deleteFile",
    method: "DELETE",
    params,
  });
}
export function lxApplyExportZip(params) {
  // ?????????
  return request({
    url: "/lx/lxApply/exportZip",
    method: "GET",
    responseType: "blob",
    params,
  });
}
export function lxApplyExportZips(params) {
  // ?????????
  return request({
    url: "/lx/lxApply/zexportZip",
    method: "GET",
    responseType: "blob",
    params,
  });
}
// ?????????
export function checkName(data) {
  return request({
    url: "/lx/lxApply/validInfo",
    method: "GET",
    params:data,
  });
}


export function getMajor1 (data) {
  return request({
    url: "/infrastructure/basicMajor/findCategory",
    method: "GET",
    params:data,
  });
}
export function getMajor2 (data) {
  return request({
    url: "/infrastructure/basicMajor/findSubclass",
    method: "GET",
    params:data,
  });
}
export function getMajor3 (data) {
  return request({
    url: "/infrastructure/basicMajor/findMajor",
    method: "GET",
    params:data,
  });
}
// ??????
export function mhSchool (data) {
  return request({
    url: "/system/schoolInfo/queryByName",
    method: "get",
    params:data,
  });
}
// ?????????????
export function getNoteCode(data) {
  return request({
    url: "/sys/getNoteCode",
    method: "GET",
    params:data,
  });
}
// ?????????????
export function getNoteCodes(data) {
  return request({
    url: "/sys/getLoginNoteCode",
    method: "GET",
    params:data,
  });
}
// ????????????????
export function getNoticeList(data) {
  return request({
    url: "/sys/annountCement/list",
    method: "GET",
    params:data,
  });
}
// ????????????????
export function getNoticeDetail(data) {
  return request({
    url: "/sys/annountCement/queryById",
    method: "GET",
    params:data,
  });
}
// ????????????
export function getSuggestion(data) {
  return request({
    url: "/lx/lxExpertApply/suggestion",
    method: "GET",
    params:data,
  });
}
// ???????????
export function lxApplyExportExcel(params) {
  // ????excel
  return request({
    url: "/lx/lxApply/exportExcel",
    method: "GET",
    responseType: "blob",
    params,
  });
}
// ???????????
export function lxApplyExportExcels(params) {
  // ????excel
  return request({
    url: "/lx/lxApply/zexportExcel",
    method: "GET",
    responseType: "blob",
    params,
  });
}
// ????
export function lxApplyApplyCancel(data) {
  // ????excel
  return request({
    url: "/lx/lxApply/reject?id="+data.id,
    method: "POST",
    data:{},
  });
}
// ---------- ???????? ----------
export function lxEnrollMyList(params) {
  return request({ url: "lx/lxCompetitionEnroll/myList", method: "get", params });
}
export function lxEnrollApprovedList() {
  return request({ url: "lx/lxCompetitionEnroll/approvedList", method: "get" });
}
export function lxEnrollCheckCanApply(params) {
  return request({ url: "lx/lxCompetitionEnroll/checkCanApply", method: "get", params });
}
export function lxEnrollSaveOrUpdate(data) {
  return request({ url: "lx/lxCompetitionEnroll/saveOrUpdate", method: "post", data });
}
export function lxEnrollJyjList(params) {
  return request({ url: "lx/lxCompetitionEnroll/jyjList", method: "get", params });
}
export function lxEnrollAudit(data) {
  return request({ url: "lx/lxCompetitionEnroll/audit", method: "post", data });
}
export function lxEnrollDelete(params) {
  return request({ url: "lx/lxCompetitionEnroll/delete", method: "delete", params });
}
export function lxEnrollUpdateRejected(data) {
  return request({ url: "lx/lxCompetitionEnroll/updateRejected", method: "post", data });
}
export function lxEnrollExportApprovedZip(params) {
  return request({
    url: "lx/lxCompetitionEnroll/exportApprovedFormsZip",
    method: "get",
    responseType: "blob",
    params,
  });
}
export function lxEnrollExportExcel(params) {
  return request({
    url: "lx/lxCompetitionEnroll/exportExcel",
    method: "get",
    responseType: "blob",
    params,
  });
}

// ---------- 初赛抽签 ----------
// 后端接口已就绪，默认走真实接口。
// 本地自测动画效果时，把下面改成 true 即可切回假数据。
const USE_LOTTERY_MOCK = false;

// 假数据：章节库（签），中职=教材名称，高职=章节/模块名称
const MOCK_CHAPTERS = {
  中职: [
    { id: "c01", sourceName: "职业道德与法治", levelType: "中职", status: "Y" },
    { id: "c02", sourceName: "职业生涯规划", levelType: "中职", status: "Y" },
    { id: "c03", sourceName: "语文（基础模块）", levelType: "中职", status: "Y" },
    { id: "c04", sourceName: "数学（基础模块）", levelType: "中职", status: "Y" },
    { id: "c05", sourceName: "英语（基础模块）", levelType: "中职", status: "Y" },
    { id: "c06", sourceName: "信息技术", levelType: "中职", status: "Y" },
    { id: "c07", sourceName: "体育与健康", levelType: "中职", status: "Y" },
    { id: "c08", sourceName: "心理健康", levelType: "中职", status: "Y" },
  ],
  高职: [
    { id: "g01", sourceName: "入学教育与军训", levelType: "高职", status: "Y" },
    { id: "g02", sourceName: "专业导论", levelType: "高职", status: "Y" },
    { id: "g03", sourceName: "工程制图", levelType: "高职", status: "Y" },
    { id: "g04", sourceName: "电工电子技术", levelType: "高职", status: "Y" },
    { id: "g05", sourceName: "程序设计基础", levelType: "高职", status: "Y" },
    { id: "g06", sourceName: "数据库应用技术", levelType: "高职", status: "Y" },
  ],
};

// 假数据：参抽团队/学校
const MOCK_TEAMS = {
  中职: [
    { id: "t1", schoolName: "大同市第一高级职业中学校" },
    { id: "t2", schoolName: "大同市第二高级职业中学校" },
    { id: "t3", schoolName: "大同市职业教育中心学校" },
    { id: "t4", schoolName: "大同市工商职业技术学校" },
    { id: "t5", schoolName: "大同市艺术职业技术学校" },
  ],
  高职: [
    { id: "g1", schoolName: "大同煤炭职业技术学院" },
    { id: "g2", schoolName: "山西通用航空职业技术学院" },
    { id: "g3", schoolName: "大同师范高等专科学校" },
  ],
};

function shuffleArr(arr) {
  const list = arr.slice();
  for (let i = list.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = list[i];
    list[i] = list[j];
    list[j] = tmp;
  }
  return list;
}

function pad(n) {
  return n < 10 ? "0" + n : "" + n;
}

// 抽签时间（本地时间，接口不返回该字段，仅用于页面展示）
export function nowText() {
  const d = new Date();
  return (
    d.getFullYear() +
    "-" +
    pad(d.getMonth() + 1) +
    "-" +
    pad(d.getDate()) +
    " " +
    pad(d.getHours()) +
    ":" +
    pad(d.getMinutes()) +
    ":" +
    pad(d.getSeconds())
  );
}

function lotteryMockChapterList(params) {
  return new Promise((resolve) => {
    setTimeout(() => {
      const levelType = (params && params.levelType) || "中职";
      resolve({
        success: true,
        code: 200,
        message: "操作成功",
        result: {
          records: MOCK_CHAPTERS[levelType] || MOCK_CHAPTERS["中职"],
          total: (MOCK_CHAPTERS[levelType] || MOCK_CHAPTERS["中职"]).length,
        },
      });
    }, 300);
  });
}

// 对应真实接口 POST /lx/lxDrawResult/draw
function lotteryMockDraw(data) {
  return new Promise((resolve) => {
    setTimeout(() => {
      const levelType = (data && data.levelType) || "中职";
      const chapters = shuffleArr(MOCK_CHAPTERS[levelType] || MOCK_CHAPTERS["中职"]);
      const teams = shuffleArr(MOCK_TEAMS[levelType] || MOCK_TEAMS["中职"]);
      const list = teams.map((item, index) => {
        const c = chapters[index % chapters.length];
        return {
          id: "r" + item.id,
          applyId: item.id,
          schoolName: item.schoolName,
          drawChapterId: c.id,
          drawNo: index + 1,
          drawRound: (data && data.drawRound) || "",
        };
      });
      resolve({
        success: true,
        code: 200,
        message: "抽签成功",
        result: list,
      });
    }, 500);
  });
}

// 接口1：抽签章节库（签）列表 —— 页面默认展示的题号池
// 参数：{ levelType: '中职' | '高职' }
// 返回 result 为数组或 { records: [...] }，页面侧统一做了兼容；名称取 sourceName
export function lxDrawChapterList(params) {
  if (USE_LOTTERY_MOCK) return lotteryMockChapterList(params);
  return request({
    url: "/lx/lxDrawChapter/list",
    method: "get",
    params,
  });
}

// 接口2：执行一次抽签
// 参数：{ levelType: '中职' | '高职', drawRound? }（分社由后端按登录用户识别，前端不传 userId）
// 返回 result 为数组：[{ id, applyId, schoolName, drawChapterId, drawNo, drawRound }]
export function lxDrawResultDraw(data) {
  if (USE_LOTTERY_MOCK) return lotteryMockDraw(data);
  return request({
    url: "lx/lxDrawResult/draw",
    method: "post",
    data,
  });
}

// 接口2-1：学校自行抽签（登录用户即学校，后端据此识别）
// 真实后端：POST lx/lxDrawResult/drawBySchool
// 参数：{ levelType: "1"中职 | "2"高职, drawRound? }
// 返回 result 为该校抽签结果对象：{ id, schoolName, drawChapterId, drawNo, ... }
export function lxDrawResultDrawBySchool(data) {
  return request({
    url: "lx/lxDrawResult/drawBySchool",
    method: "post",
    data,
  });
}

// 接口2-2：学校获取自己的抽签结果
// 真实后端：GET lx/lxDrawResult/myDrawStatList
// 返回 result 为单个结果对象；未抽签时 result 为 null
export function lxDrawResultMyDrawStatList(params) {
  return request({
    url: "lx/lxDrawResult/myDrawStatList",
    method: "get",
    params,
  });
}

// 假数据：抽签结果统计（结果公示页演示用，跨分社、跨组别）
const MOCK_STAT_BRANCHES = ["大同分社", "朔州分社", "忻州分社"];

function lotteryMockStatList() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const branchNo = {};
      const records = [];
      let id = 0;
      Object.keys(MOCK_TEAMS).forEach((levelText) => {
        const chapters = MOCK_CHAPTERS[levelText];
        MOCK_TEAMS[levelText].forEach((t, ti) => {
          const branch =
            MOCK_STAT_BRANCHES[
              (ti + (levelText === "高职" ? 2 : 0)) % MOCK_STAT_BRANCHES.length
            ];
          branchNo[branch] = (branchNo[branch] || 0) + 1;
          const c = chapters[ti % chapters.length];
          id += 1;
          records.push({
            id: "stat" + id,
            applyId: t.id,
            branchName: branch,
            schoolName: t.schoolName,
            levelType: levelText,
            levelTypeDictText: levelText,
            drawNo: branchNo[branch],
            drawChapterId: c.id,
            drawName: c.sourceName,
            createTime: "2026-09-02 10:30:00",
          });
        });
      });
      resolve({
        success: true,
        code: 200,
        message: "操作成功",
        result: {
          records,
          total: records.length,
        },
      });
    }, 300);
  });
}

// 接口3：抽签结果统计列表（分页，含分社名称与抽中名称 drawName）
// 参数：{ pageNo, pageSize, drawRound?, drawNo?, applyId? }
export function lxDrawResultStatList(params) {
  if (USE_LOTTERY_MOCK) return lotteryMockStatList();
  return request({
    url: "lx/lxDrawResult/statList",
    method: "get",
    params,
  });
}

// 接口4：按当前登录分社查询抽签结果统计 —— 用于进页面判断「是否已抽签完成」
// 参数：{ levelType: '中职' | '高职', drawRound? }（分社由后端按登录用户识别，前端不传 userId）
// 返回 result 为分页对象，records 每项含 schoolName / drawNo / drawChapterId / drawName 等（与 statList 同构）
// records 非空 = 该分社该组别已抽签完成
export function lxDrawResultStatListByBranch(params) {
  return request({
    url: "lx/lxDrawResult/statListByBranch",
    method: "get",
    params,
  });
}

// 接口5：抽签结果公示导出 Excel（返回二进制流）
// 参数与 statList 一致：{ levelType?, branchName?, drawRound? }
export function lxDrawResultExportXls(params) {
  return request({
    url: "lx/lxDrawResult/exportStatList",
    method: "get",
    responseType: "blob",
    params,
  });
}

// 接口7：抽签页（分社视角）导出 Excel —— 导出当前分社的抽签结果，返回二进制流
// 参数与 statListByBranch 一致：{ levelType: '1' | '2', drawRound? }
export function lxDrawResultExportByBranch(params) {
  return request({
    url: "lx/lxDrawResult/exportStatListByBranch",
    method: "get",
    responseType: "blob",
    params,
  });
}

// 接口6：分社名称列表 —— 公示页「分社」下拉选项
// 返回 result 兼容：字符串数组 / { records: [...] } / 对象数组（branchName | name）
export function lxDrawResultBranchNames(params) {
  return request({
    url: "lx/lxDrawResult/branchNames",
    method: "get",
    params,
  });
}

// 接口8：下载「抽签学校」导入模板（返回二进制流）
// 真实后端：GET lx/lxDrawTeam/exportTemplate
// 返回 Excel 模板，前端用 blob 触发下载
export function lxDrawResultSchoolTemplate(params) {
  return request({
    url: "lx/lxDrawTeam/exportTemplate",
    method: "get",
    responseType: "blob",
    params,
  });
}

// 接口9：导入「抽签学校」（上传 Excel，multipart/form-data）
// 真实后端：POST lx/lxDrawTeam/importExcel
// 参数：FormData { file: <File>, levelType: '1' | '2', drawRound? }
// 返回 jeecg 统一结构 { success, code, message }
export function lxDrawResultImportSchool(data) {
  return request({
    url: "lx/lxDrawTeam/importExcel",
    method: "post",
    data,
  });
}

// 接口10：查询已导入抽签的学校列表
// 真实后端：GET lx/lxDrawTeam/list
// 参数：{ userId: 登录用户id, levelType: '1' | '2' }
// 返回：该用户、该组别下已导入成功的学校数组（result 为数组 或 { records: [...] }）
export function lxDrawTeamList(params) {
  return request({
    url: "lx/lxDrawTeam/list",
    method: "get",
    params,
  });
}

// 接口11：编辑已导入的抽签学校
// 真实后端：PUT lx/lxDrawTeam/edit
export function lxDrawTeamEdit(data) {
  return request({
    url: "lx/lxDrawTeam/edit",
    method: "put",
    data,
  });
}

// 接口12：删除已导入的抽签学校
// 真实后端：DELETE lx/lxDrawTeam/delete?id=
export function lxDrawTeamDelete(params) {
  return request({
    url: "lx/lxDrawTeam/delete",
    method: "delete",
    params,
  });
}

// ---------- 报名表上传（lxDrawFile）----------

// 上传 Word 转 PDF 成功后，保存文件记录
// 真实后端：POST lx/lxDrawFile/add
// 参数：{ branchId: 登录人id, filePath: 文件路径, previewPath: 预览路径, coverImgPath, fileSize, format, resType, size, title, totalTime, zyresId }
export function lxDrawFileAdd(data) {
  return request({
    url: "lx/lxDrawFile/add",
    method: "post",
    data,
  });
}

// 进入页面默认查询当前登录人的报名表记录
// 真实后端：GET lx/lxDrawFile/list?branchId=登录人id
export function lxDrawFileList(params) {
  return request({
    url: "lx/lxDrawFile/list",
    method: "get",
    params,
  });
}
// 进入页面默认查询当前登录人的报名表记录
// 真实后端：GET lx/lxDrawFile/list?branchId=登录人id
export function lxDrawFileEdit(data) {
  return request({
    url: "lx/lxDrawFile/edit",
    method: "put",
    data,
  });
}

// 接口13：获取「报名表」模板静态路径
// 真实后端：GET lx/lxDrawTeam/downloadTeamForm
// 返回 JSON：{ code, message, result, success, timestamp }
// result 是文件相对路径，例：sys/common/static/template/参赛团队报名表.docx
// 前端拿到后用 baseURL 拼成完整 URL，再 <a download> 触发下载
export function lxDrawTeamDownloadTeamForm(params) {
  return request({
    url: "lx/lxDrawTeam/downloadTeamForm",
    method: "get",
    params,
  });
}

// 接口14：导出全部报名表（打包为 zip）
// 真实后端：GET lx/lxDrawTeam/exportAllTeamForms
// 返回 JSON：{ success, code, result }
// result 是 zip 相对路径，例：sys/common/static/template_zip/抽签报名表_20260908120000.zip
// 前端拿到后用 baseURL 拼成完整 URL，再 <a download> 触发下载
export function lxDrawTeamExportAllTeamForms(params) {
  return request({
    url: "lx/lxDrawTeam/exportAllTeamForms",
    method: "get",
    params,
  });
}